// extracted by mini-css-extract-plugin
export default {"wrapper":"Page_wrapper__KjUpf","header":"Page_header__QiUNC","goBack":"Page_goBack__a8rxc","title":"Page_title__6Gea5","pageContent":"Page_pageContent__Jvo3-"};